var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLookbookUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 360",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "lookbookUnavailableGlow",
    cx: "50%",
    cy: "42%",
    r: "58%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8b4b4",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e8b4b4",
    stopOpacity: 0
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 178,
    rx: 178,
    ry: 152,
    fill: "url(#lookbookUnavailableGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 168 L198 152 L204 286 L80 296 Z",
    fill: "#e8b4b4",
    stroke: "#c48a8a",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198 152 L324 170 L330 292 L204 286 Z",
    fill: "#d4a0a0",
    stroke: "#c48a8a",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198 152 L204 286",
    stroke: "#b56b6b",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 192 L170 184",
    stroke: "#c48a8a",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 214 L168 206",
    stroke: "#c48a8a",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108 236 L166 228",
    stroke: "#c48a8a",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 188,
    width: 52,
    height: 64,
    rx: 6,
    fill: "#c48a8a",
    opacity: 0.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 198,
    width: 28,
    height: 36,
    rx: 4,
    fill: "#e8b4b4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248 58        C 232 58 220 72 220 88        C 220 104 228 116 236 128        L 230 152        C 168 178 138 248 146 308        C 186 298 226 304 248 312        C 270 304 310 298 350 308        C 358 248 328 178 266 152        L 260 128        C 268 116 276 104 276 88        C 276 72 264 58 248 58 Z",
    fill: "#d4a0a0",
    stroke: "#b56b6b",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236 88 C 240 102 256 102 260 88",
    stroke: "#b56b6b",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238 152 C 244 168 252 168 258 152",
    stroke: "#b56b6b",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248 42 L248 58",
    stroke: "#c48a8a",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228 48 C 236 40 260 40 268 48",
    stroke: "#c48a8a",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96 C 80 90 80 80 88 76 C 94 74 100 78 102 84 C 104 78 110 74 116 76 C 124 80 124 90 118 96 L 102 110 Z",
    fill: "#d4a0a0",
    stroke: "#b56b6b",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M348 78 L356 90 L348 88 L340 90 Z",
    fill: "#c48a8a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72 250 L80 258 L72 256 L64 258 Z",
    fill: "#c48a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookbookUnavailable);
export default __webpack_public_path__ + "static/media/lookbook-unavailable.4ea85993184f5a1ab61f4191e5fa9ffc.svg";
export { ForwardRef as ReactComponent };